<template>
  <GwMenu
    class="upload-menu"
    placement="bottom"
    :isOpen="isOpen"
  >
    <template #opener>
      <slot></slot>
    </template>
    <div
      class="f-column gw_menu"
      style="max-height: 320px; overflow: auto; padding: 0"
      data-tst="upload_progress_items"
      @click="
        $router
          .push({
            name: 'AnalyzeFilesV4',
            params: {
              unused: 'files',
            },
          })
          .catch(() => {})
      "
    >
      <UploadProgressItem
        v-for="(item, idx) in allUploads"
        :key="item.status + idx"
        :totalProgress="item.totalProgress"
        :failed="item.failed"
        :filesLength="item.filesLength"
        :status="item.status"
        class="upload-menu_item px-4"
        @click:retry="$emit('click:retry')"
      />
      <div
        style="background: var(--clr-black-1)"
        class="bt-grey text-small clr-grey px-4 py-2 cursor-pointer mt-2"
      >
        {{ $t(`analyze.upload.check_uploads_status`) }}
      </div>
    </div>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import UploadProgressItem from '@/components/UploadBoxes/UploadProgressItem'

export default {
  name: 'UploadMenu',
  components: {
    GwMenu,
    UploadProgressItem,
  },
  props: {
    uploads: { default: () => [] },
  },
  emits: ['click:retry'],
  data() {
    return {}
  },
  computed: {
    isOpen() {
      return this.uploads.length > 0
    },
    allUploads() {
      // merge upload batches together
      const uploads = this.uploads.filter(i => !i.placeholder)
      const done = !uploads.some(i => i.status === 'progress')
      return [
        {
          status: done ? 'finished' : 'progress',
          totalProgress: uploads[0]?.totalProgress || 0,
          filesLength: uploads.reduce((acc, i) => acc + i.filesLength, 0),
          failed: uploads.reduce((acc, i) => (i.failed?.length ? [...acc, ...i.failed] : acc), []),
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-menu {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
